// extracted by mini-css-extract-plugin
export var accountsListContainer = "bx_fd";